import { createStore } from 'vuex'

export default createStore({
  state: {
    user:{
      token: '',
      isAuthenticated: false,
    }
  },
  getters: {
  },
  mutations: {
    initializeStore(state){
      if (localStorage.getItem('token')){
        state.user.token = localStorage.getItem('token')
        state.user.isAuthenticated = true
      } else {
        state.user.token = ''
        state.user.isAuthenticated = false
      }
    },
    setToken(state, token){
      state.user.token = token
      state.user.isAuthenticated = true
    },
    removeToken(state){
      state.user.token = ''
      state.user.isAuthenticated = false
    },
  },
  actions: {
  },
  modules: {
  }
})
